import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "btn-vitalis inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border text-sm font-medium transition-[background-color,border-color,transform,box-shadow] duration-150 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 active:translate-y-px [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "btn-primary border-[#075985] bg-[#0369A1] text-white shadow-sm hover:bg-[#075985] active:bg-[#0C4A6E]",
        destructive:
          "btn-danger border-[#B91C1C] bg-[#DC2626] text-white shadow-sm hover:bg-[#B91C1C] active:bg-[#991B1B]",
        outline:
          "btn-secondary border-[#475569] bg-[#64748B] text-white shadow-sm hover:bg-[#475569] active:bg-[#334155]",
        secondary:
          "btn-secondary border-[#475569] bg-[#64748B] text-white shadow-sm hover:bg-[#475569] active:bg-[#334155]",
        ghost: "border-transparent hover:bg-[#DBEAFE] hover:text-[#0369A1] active:bg-[#BFDBFE]",
        link: "border-transparent text-[#0369A1] underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
